(() => {
 'use strict';
 const bar=document.querySelector('[data-funnel-product-progress]');if(!bar)return;
 const key='ss-bible-funnel-v2';
 try{
  const state=JSON.parse(sessionStorage.getItem(key));const url=new URL(location.href);
  if(url.searchParams.get('ss_funnel')!=='1'||!state?.product||Date.now()-state.updated>86400000)return;
  const selected=new URL(state.product.url,location.origin);
  if(selected.origin!==location.origin||selected.pathname!==bar.dataset.productPath)return;
  const collection=new URL(state.collection,location.origin);if(collection.origin!==location.origin||!collection.pathname.startsWith('/collections/'))return;
  bar.querySelector('[data-funnel-choice-link]').href=state.mode==='photo'?'/pages/customize-your-bible-photo-translation':state.mode==='design'?'/pages/customize-your-bible-readymade-designs':'/pages/customize-your-bible-translation';
  bar.querySelector('[data-funnel-choice-link]').textContent=state.mode==='design'?'✓ Design':'✓ Translation';
  bar.querySelector('[data-funnel-collection-link]').href=collection.pathname;
  const css=document.createElement('link');css.rel='stylesheet';css.href=bar.dataset.css;document.head.append(css);
  if(state.mode==='photo')bar.querySelector('[aria-current="step"]').textContent='4 · Upload photo';
  bar.hidden=false;
  // Only a deliberate funnel handoff opens the existing app. Consume the marker
  // before opening so refresh or closing the editor cannot reopen it in a loop.
  if(url.searchParams.get('ss_customize')==='1'){
   url.searchParams.delete('ss_customize');
   history.replaceState(null,'',url.pathname+url.search+url.hash);
   const target=document.getElementById('live-product-options-atc');
   if(target){
    let stopped=false,pending=false;
    const stop=()=>{stopped=true;observer.disconnect();clearTimeout(deadline);};
    const attempt=()=>{
     if(stopped||pending)return;
     const input=target.querySelector('input[type="radio"][name="properties[Customize The Bible]"][value="yes"]');
     const control=input?.closest('label');
     if(!input||input.disabled||!control||!control.getClientRects().length)return;
     pending=true;
     // Let the app finish binding the newly rendered control before activation.
     setTimeout(()=>{
      if(stopped)return;
      const popup=document.querySelector('.cl-po--popup');
      const alreadyOpen=popup&&popup.getClientRects().length&&getComputedStyle(popup).visibility!=='hidden';
      stop();
      if(!alreadyOpen&&control.isConnected&&!input.disabled)control.click();
     },250);
    };
    const observer=new MutationObserver(attempt);
    const deadline=setTimeout(stop,20000);
    observer.observe(target,{childList:true,subtree:true,attributes:true});
    attempt();
    // A user choosing to leave the guided flow cancels a pending auto-open.
    bar.querySelector('[data-funnel-exit]').addEventListener('click',stop,{once:true});
   }
  }
  bar.querySelector('[data-funnel-exit]').addEventListener('click',e=>{e.preventDefault();url.searchParams.delete('ss_funnel');history.replaceState(null,'',url.pathname+url.search+url.hash);bar.hidden=true;sessionStorage.removeItem(key);});
 }catch{/* Storage blocked or direct product visit: retain the normal product page. */}
})();
